import ActionTypes from '../../../../constants/ActionTypes';
import { SendVoucherData } from './types';

export const sendVoucherForVerification = (data: SendVoucherData): any => ({
  type: ActionTypes.ORDER.VOUCHER.SEND_FOR_VERIFICATION,
  payload: data,
});

export const sendAccessoriesVoucherForVerification = (data: SendVoucherData): any => ({
  type: ActionTypes.ORDER.ACCESSORY.VOUCHER.SEND_FOR_VERIFICATION,
  payload: data,
});

export const sendGreenVoucherForVerification = (data: SendVoucherData): any => ({
  type: ActionTypes.ORDER.GREEN_VOUCHER.SEND_FOR_VERIFICATION,
  payload: data,
});

export const setVoucherCode = (code: string): any => ({
  type: ActionTypes.ORDER.VOUCHER.SET_VOUCHER_CODE,
  payload: code,
});

type SetVoucherAppliedData = {
  voucherSerialNumber: string;
  voucherValue: string;
  voucherDate: string;
};

type DeviceNumberSpecifiedData = null | 1 | 2 | 3;
export const setVoucherApplied = (data: SetVoucherAppliedData) => ({
  type: ActionTypes.ORDER.GREEN_VOUCHER.SET_VOUCHER_APPLIED,
  payload: data,
});

export const setVoucherApplicationFailed = (message: string) => ({
  type: ActionTypes.ORDER.GREEN_VOUCHER.SET_VOUCHER_FAILED_MESSAGE,
  payload: message,
});

export const setDeviceNumberSpecified = (deviceNumberSpecified: DeviceNumberSpecifiedData) => ({
  type: ActionTypes.ORDER.GREEN_VOUCHER.SET_DEVICE_NUMBER_SPECIFIED,
  payload: deviceNumberSpecified,
});

export const clearAppliedGreenVoucher = () => ({
  type: ActionTypes.ORDER.GREEN_VOUCHER.CLEAR_APPLIED_VOUCHER,
});

export const setMsisdnRequired = (status: boolean): any => ({
  type: ActionTypes.ORDER.VOUCHER.SET_MSISDN_REQUIRED,
  payload: status,
});

